// Mobile PDP gallery — tap thumbnail = swap main image.
// Desktop ma 2-col grid wszystkich zdjęć, JS się tam nie odpala.

function initPdpGallery() {
  const main = document.querySelector('[data-pdp-main]');
  if (!main) return;
  const thumbs = document.querySelectorAll('[data-pdp-thumb]');
  if (!thumbs.length) return;

  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => {
      const src = btn.getAttribute('data-main-src');
      if (!src || main.src === src) return;
      // Krótki fade — zmiana src bez błysku.
      main.style.opacity = '0.4';
      const img = new Image();
      img.onload = () => {
        main.src = src;
        main.style.opacity = '1';
      };
      img.onerror = () => { main.style.opacity = '1'; };
      img.src = src;
      thumbs.forEach((b) => {
        b.classList.remove('ring-black');
        b.classList.add('ring-black/10');
      });
      btn.classList.remove('ring-black/10');
      btn.classList.add('ring-black');
    });
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initPdpGallery();
  else document.addEventListener('DOMContentLoaded', initPdpGallery);
}
